<template lang="">
  <div class="jobs-page">
    <AppNavbar @login-click="goToLogin" @start-click="goToLogin" />
    <JobList />
    <AppFooter />
  </div>
</template>

<script>
import { useRouter } from 'vue-router';
import AppFooter from '../../components/ui/AppFooter.vue';
import AppNavbar from '../../components/ui/AppNavbar.vue';
import JobList from '../../components/Elements/Jobs/JobList.vue';

export default {
  name: 'JobsList',
  components: {
    AppFooter,
    AppNavbar,
    JobList,
  },
  setup() {
    const router = useRouter();

    const goToLogin = () => {
      router.push({ name: 'Login' });
    };

    return {
      goToLogin,
    };
  },
};
</script>

<style scoped>
.jobs-page {
  background: var(--navy-deep);
  min-height: 100vh;
}
</style>
